var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeHighFive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / badge_high-five") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-badge_high-five",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#A7ACB0",
    strokeWidth: 0,
    cx: 23,
    cy: 23,
    r: 23
  }), /*#__PURE__*/React.createElement("g", {
    id: "high_five",
    transform: "translate(8.000000, 8.000000)",
    stroke: "#0F2B41",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6960465,12.8622753 L16.6960465,5.72464159 C16.6960465,4.61539668 17.524808,3.71651428 18.5472367,3.71651428 C19.5703331,3.71651428 20.3990947,4.61539668 20.3990947,5.72464159 L20.3990947,13.6816874 L20.3990947,8.91948065 C20.3990947,7.81023573 21.2278562,6.91068552 22.2502848,6.91068552 C23.2727135,6.91068552 24.1021429,7.81023573 24.1021429,8.91948065 L24.1021429,17.8742459 C23.6360062,21.99468 21.1203376,26.9325229 15.2495537,26.9325229 C12.7806323,26.8670767 9.93773307,25.4419541 8.1673488,22.5536433 L3.70499208,14.8577141 C3.61884362,14.6560332 3.57142857,14.4329822 3.57142857,14.199246 C3.57142857,13.2636337 4.33006928,12.504993 5.26568164,12.504993 C5.85002198,12.504993 6.36557711,12.8008361 6.6701019,13.251613 L9.30530987,16.3015356 L9.30530987,6.5594135 C9.30530987,5.44883295 10.1340714,4.54995056 11.1571679,4.54995056 C12.1795965,4.54995056 13.0083581,5.44883295 13.0083581,6.5594135 L12.9929983,12.8622753 L12.9929983,3.43736655 C12.9929983,2.32812164 13.8217598,1.42857143 14.8448563,1.42857143 C15.8672849,1.42857143 16.6960465,2.32812164 16.6960465,3.43736655 L16.6960465,12.8622753 Z",
    id: "Stroke-1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeHighFive);
export default __webpack_public_path__ + "static/media/badgeHighFive.c654b97bb41b1b6de9f6e695d6f5336b.svg";
export { ForwardRef as ReactComponent };